var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyGer3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.533936,
    width: 47,
    height: 47.8136,
    rx: 11.5,
    fill: "#F8FAFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.533936,
    width: 47,
    height: 47.8136,
    rx: 11.5,
    stroke: "#C4D8FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2851_3994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5311 23.5652H37.0875V17.2896C37.0875 17.0307 36.8777 16.8208 36.6187 16.8208C36.3598 16.8208 36.15 17.0307 36.15 17.2896V23.5652H35.1462V8.97144H36.15V15.2471C36.15 15.5059 36.3598 15.7158 36.6187 15.7158C36.8777 15.7158 37.0875 15.5059 37.0875 15.2471V8.50269C37.0875 8.24381 36.8777 8.03394 36.6187 8.03394H34.6774C34.4185 8.03394 34.2087 8.24381 34.2087 8.50269V9.97544H27.8827C27.6238 9.97544 27.414 10.1853 27.414 10.4442V11.9171H22.0587C21.6377 12.0042 21.5077 12.2471 21.6687 12.6458L23.4366 15.2977L21.6687 17.9496C21.5077 18.3482 21.6377 18.5911 22.0587 18.6783H29.8024C30.0614 18.6783 30.2712 18.4684 30.2712 18.2096V16.7371H34.2087V23.5652H31.7656C31.5066 23.5652 31.2968 23.7751 31.2968 24.0339V27.4477H28.9044C28.6454 27.4477 28.4356 27.6576 28.4356 27.9164C28.4356 28.1753 28.6454 28.3852 28.9044 28.3852H31.2968V39.0964H24.4688V28.3852H26.8612C27.1202 28.3852 27.33 28.1753 27.33 27.9164C27.33 27.6576 27.1202 27.4477 26.8612 27.4477H24C23.7411 27.4477 23.5312 27.6576 23.5312 27.9164V31.3307H16.2344C15.9755 31.3307 15.7657 31.5406 15.7657 31.7995V35.2133H13.0825C12.8236 35.2133 12.6137 35.4232 12.6137 35.6821C12.6137 35.9409 12.8236 36.1508 13.0825 36.1508H15.7656V39.0964H8.9375V36.1508H11.0394C11.2983 36.1508 11.5081 35.9409 11.5081 35.6821C11.5081 35.4232 11.2983 35.2133 11.0394 35.2133H8.46875C8.20981 35.2133 8 35.4232 8 35.6821V39.5652C8 39.8241 8.20981 40.0339 8.46875 40.0339L39.5311 40.0338C39.7901 40.0338 39.9999 39.8239 39.9999 39.5651V24.0339C39.9999 23.7751 39.7901 23.5652 39.5311 23.5652ZM29.3337 17.7408H22.9346L24.39 15.5577C24.495 15.4002 24.495 15.1951 24.39 15.0377L22.9346 12.8546H27.414V16.2684C27.414 16.5272 27.6238 16.7371 27.8827 16.7371H29.3337V17.7408ZM28.3515 15.7996V10.9129H34.2087V15.7996H28.3515ZM16.7032 32.2682H23.5312V39.0963H16.7032V32.2682ZM39.0624 39.0963H32.2344L32.2343 24.5027H39.0624V39.0963Z",
    fill: "#1A202C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2851_3994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8.03394)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyGer3);
export default __webpack_public_path__ + "static/media/whyGer3.2716569f0b68814f4c39b56d9e51012e.svg";
export { ForwardRef as ReactComponent };